import { render, staticRenderFns } from "./ProjectNucleiManagement.vue?vue&type=template&id=925c4d7e&scoped=true"
import script from "./ProjectNucleiManagement.vue?vue&type=script&lang=js"
export * from "./ProjectNucleiManagement.vue?vue&type=script&lang=js"
import style0 from "./ProjectNucleiManagement.vue?vue&type=style&index=0&id=925c4d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925c4d7e",
  null
  
)

export default component.exports